import { apiCall } from 'app/shared/lib/essette-api';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { autoinject } from 'aurelia-framework';
import { MemberService } from 'app/cd/services/member-service';
import { Toaster } from 'app/shared/lib/toaster';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class SaveEthnicityCustomElement extends ComponentBase implements IForm {
    ////****************** Fields and Properties ************************************////
    public editedEthnicity?: CD.Ethnicity;

    constructor(
        private readonly service: MemberService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const isSuccess = await this.saveEthnicity();
        return isSuccess;
    }

    public reset(): void {

    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    public async saveEthnicity(): Promise<boolean> {

        if(!this.editedEthnicity) return false;
        let isSuccessful = false;
        this.editedEthnicity.description = this.editedEthnicity.$display;
        let message: string = '';
        try {
            this.state.beginSave();
            const response = await this.service.saveEthnicity(this.editedEthnicity);
            isSuccessful = response.isSuccessful;
        } catch(error) {
            if(error.description) { message = error.description; }
            throw error;
        } finally {
            this.reset();
            if(isSuccessful) {
                if(!this.editedEthnicity.id) { this.toaster.standard.created('cd:member.ethnicity.$', isSuccessful); }
                else { if(this.editedEthnicity.id) { this.toaster.standard.updated('cd:member.ethnicity.$', isSuccessful); } }
            }
            else {
                if(!isSuccessful) {
                    const exception = (this.toaster.toast())
                        .title('Error')
                        .class('ess-toast-error')
                        .icon('ui:icons.error')
                        .message(message)
                    exception.show();
                }
            }
            this.reset();
            this.state.endSave();
            return true;
        }
    }

}
